import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { apiUrl } from "../ApiManager/AxiosHeaders";
import { Link } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import { healthProviders } from "../../utilis/constants";
import Swal from "sweetalert2";

function MedicalInsurance() {
  const [data, setData] = useState([]);
  const [skeleton, setSkeleton] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    perPage: 10,
    total: 0,
    lastPage: 1,
  });
  const [openModal, setOpenMoal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});

  const [selectedRecord, setSelectedRecord] = useState(null);
  const [filterKey, setFilterKey] = useState(0);

  const [filters, setFilters] = useState({
    clientName: "",
    issueDate: "",
    ExpireyDate: "",
    IsuranceProvider: "",
  });

  const [formData, setFormData] = useState({
    startDate: "",
    endDate: "",
    amount: "",
    provider: "",
    receiptFile: null,
    certificateFile: null,
  });

  useEffect(() => {
    if (selectedRecord) {
      setFormData({
        startDate: selectedRecord?.oshc_records?.issue_date || "",
        endDate: selectedRecord?.oshc_records?.expiry_date || "",
        amount:
          selectedRecord?.oshc_records?.amount != null
            ? String(selectedRecord?.oshc_records?.amount)
            : "",
        provider: selectedRecord?.oshc_records?.provider_name || "",
        receiptFile: null,
        certificateFile: null,
      });
    }
  }, [selectedRecord]);
  const applyFilters = () => {
    setFilterKey((prev) => prev + 1);

    setPagination((prev) => ({
      ...prev,
      currentPage: 1,
    }));
  };

  const clearFilters = () => {
    setFilters({
      clientName: "",
      issueDate: "",
      ExpireyDate: "",
      IsuranceProvider: "",
    });
    setFilterKey((prev) => prev + 1);

    setPagination((prev) => ({
      ...prev,
      currentPage: 1,
    }));
  };

  const handlePageChange = (selectedItem) => {
    setPagination((prev) => ({
      ...prev,
      currentPage: selectedItem.selected + 1,
    }));
  };

  const handlePerPageChange = (e) => {
    setPagination((prev) => ({
      ...prev,
      perPage: parseInt(e.target.value),
      currentPage: 1,
    }));
  };

  useEffect(() => {
    fetchClientNeedInsurance();
  }, [pagination.currentPage, pagination.perPage, filterKey]);

  const fetchClientNeedInsurance = async () => {
    try {
      setSkeleton(true);
      const response = await apiUrl.get("/userHealthInsurance", {
        params: {
          page: pagination.currentPage,
          per_page: pagination.perPage,
          clientName: filters.clientName || undefined,
          issueDate: filters.issueDate || undefined,
          expiryDate: filters.ExpireyDate || undefined,
          insuranceProvider: filters.IsuranceProvider || undefined,
        },
      });
      console.log("thisisresponse", response);
      if (response?.data?.success) {
        setData(response?.data?.data);
        setPagination((prev) => ({
          ...prev,
          total: response?.data?.pagination?.total,
          lastPage: response?.data?.pagination?.lastPage,
          currentPage: response?.data?.pagination?.currentPage,
        }));
      }
    } catch (error) {
    } finally {
      setSkeleton(false);
    }
  };

  // save client insurance
  const handleSave = () => {
    const start = formData.startDate?.trim();
    const end = formData.endDate?.trim();
    const amount =
      formData.amount != null ? String(formData.amount).trim() : "";
    const provider = formData.provider?.trim?.() || formData.provider || "";
    const receipt = formData.receiptFile;
    const certificate = formData.certificateFile;

    const errors = {};

    if (!start) errors.startDate = "Start Date is required.";
    if (!end) errors.endDate = "End Date is required.";
    if (start && end && new Date(end) < new Date(start)) {
      errors.endDate = "End Date cannot be earlier than Start Date.";
    }
    if (!provider) errors.provider = "Provider is required.";
    if (!amount || isNaN(amount) || parseFloat(amount) <= 0) {
      errors.amount = "Amount must be a positive number.";
    }

    if (!receipt) errors.receiptFile = "OSHC Receipt is required.";
    if (!certificate) errors.certificateFile = "OSHC Certificate is required.";

    setFieldErrors(errors);

    if (Object.keys(errors).length === 0) {
      submitForm();
    }
  };
  // if no error then submit form
  const submitForm = async () => {
    setLoading(true);

    try {
      const payload = new FormData();
      payload.append("start_date", formData.startDate);
      payload.append("end_date", formData.endDate);
      payload.append("amount", parseFloat(formData.amount));
      payload.append("provider", formData.provider);
      payload.append("clientID", selectedRecord.client_id);
      payload.append("application_type", selectedRecord?.application_type);

      if (formData.receiptFile) payload.append("receipt", formData.receiptFile);
      if (formData.certificateFile)
        payload.append("certificate", formData.certificateFile);

      const response = await apiUrl.post("/addHealthInsurance", payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data?.success) {
        setOpenMoal(false);
        Swal.fire({
          title: "Client Insurance Successfully",
          icon: "success",
          timer: 3000,
          showConfirmButton: false,
          toast: true,
          position: "top-end",
        });
        fetchClientNeedInsurance();
      }
    } catch (error) {
      console.error("Submission error:", error);
    } finally {
      setLoading(false);
    }
  };
  // skeleton
  const renderSkeletonRows = () => {
    return Array.from({ length: pagination.perPage }).map((_, index) => (
      <tr key={`skeleton-${index}`}>
        <td>
          <div className="skeleton h-5 w-32 rounded"></div>
        </td>
        <td>
          <div className="skeleton h-5 w-24 rounded"></div>
        </td>
        <td>
          <div className="skeleton h-5 w-24 rounded"></div>
        </td>
        <td>
          <div className="skeleton h-5 w-20 rounded"></div>
        </td>
        <td>
          <div className="skeleton h-5 w-20 rounded"></div>
        </td>
        <td>
          <div className="skeleton h-5 w-16 rounded"></div>
        </td>
        <td>
          <div className="skeleton h-5 w-16 rounded"></div>
        </td>
        <td className="flex gap-1">
          <div className="skeleton h-5 w-4 rounded"></div>
          <div className="skeleton h-5 w-4 rounded"></div>
          <div className="skeleton h-5 w-4 rounded"></div>
        </td>
      </tr>
    ));
  };

  const handleMarkNotNeeded = async (
    clientID,
    applicationId,
    applicationType,
  ) => {
    const result = await Swal.fire({
      title: "Mark as Not Needed?",
      text: "This client will be marked as not requiring or Buy OSHC.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Mark It",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#dc3545",
    });

    if (!result.isConfirmed) return;

    try {
      setLoading(true);

      const response = await apiUrl.post("/markInsuranceNotNeeded", {
        clientID: clientID,
        application_id: applicationId,
        application_type: applicationType,
      });

      if (response.data?.success) {
        Swal.fire({
          title: "Marked!",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
          toast: true,
          position: "top-end",
        });
        fetchClientNeedInsurance();
      }
    } catch (error) {
      console.error("Mark not needed error:", error);
      Swal.fire("Error", "Failed to update", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="card bg-white">
        <div className="px-4 py-3 bg-white">
          <header className="mb-3">
            <div className="container px-4">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <h1 className="h3 fw-bold">Health Cover Management</h1>
                  <p className="text-muted small">
                    View and manage health cover/travel insurance details and
                    coverage for clients.
                  </p>
                </div>
              </div>
            </div>
          </header>
        </div>
        {/* filters */}
        <div className="mb-6 bg-gray-50 rounded-lg border border-gray-200 p-4">
          {/* Flex Container for Filters */}
          <div className="px-3 mb-4">
            <div className="row g-3 align-items-end">
              {/* Client Name */}
              <div className="col-3">
                <label className="form-label small">Client Name</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Name or client/user ID"
                  value={filters.clientName}
                  onChange={(e) =>
                    setFilters({ ...filters, clientName: e.target.value })
                  }
                />
              </div>

              {/* Issue Date */}
              <div className="col-3">
                <label className="form-label small">Issue Date</label>
                <input
                  type="date"
                  className="form-control form-control-sm"
                  value={filters.issueDate}
                  onChange={(e) =>
                    setFilters({ ...filters, issueDate: e.target.value })
                  }
                />
              </div>

              {/* Expiry Date */}
              <div className="col-3">
                <label className="form-label small">Expiry Date</label>
                <input
                  type="date"
                  className="form-control form-control-sm"
                  value={filters.ExpireyDate}
                  onChange={(e) =>
                    setFilters({ ...filters, ExpireyDate: e.target.value })
                  }
                />
              </div>

              {/* Insurance Provider */}
              <div className="col-3">
                <label className="form-label small">Provider</label>
                {/* <select
                  className="form-select form-select-sm"
                  value={filters.IsuranceProvider}
                  onChange={(e) =>
                    setFilters({ ...filters, IsuranceProvider: e.target.value })
                  }
                >
                  <option value="">All Providers</option>
                  {healthProviders?.map((v, i) => (
                    <option key={i} value={v.title}>
                      {v.title}
                    </option>
                  ))}
                </select> */}
                <select
                  className="form-select app-form col-7"
                  name="provider"
                  value={formData.provider || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFormData({ ...formData, provider: value });
                    if (fieldErrors.provider) {
                      setFieldErrors({ ...fieldErrors, provider: "" });
                    }
                  }}
                >
                  <option value="">Select Provider... </option>
                  {healthProviders?.map((v, index) => (
                    <option key={index} className="light" value={v.title}>
                      {v.title}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          {/* Action Buttons */}
          <div className="d-flex justify-content-end gap-2">
            <button
              onClick={clearFilters}
              className="btn btn-light"
              style={{ border: "1px solid #d1d5db", fontWeight: 500 }}
            >
              Clear All
            </button>
            <button
              onClick={applyFilters}
              className="btn btn-primary"
              style={{ fontWeight: 500 }}
            >
              Apply Filters
            </button>
          </div>
        </div>
        <div className="px-3">
          {/* table */}
          <table className="table w-full">
            <thead>
              <tr>
                <th className="text-start align-middle">Client Name</th>
                <th className="text-start align-middle">Provider Name</th>
                <th className="text-start align-middle">Application Type</th>
                <th className="text-start align-middle">Issue Date</th>
                <th className="text-start align-middle">Expiry Date</th>
                <th className="text-start align-middle">Amount</th>
                <th className="text-start align-middle">Insurance Provider</th>
                <th className="text-start align-middle">Actions</th>
              </tr>
            </thead>
            <tbody>
              {skeleton ? (
                renderSkeletonRows()
              ) : data?.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center py-4 text-muted">
                    No medical insurance records found.
                  </td>
                </tr>
              ) : (
                data?.map((item, index) => (
                  <tr key={item.id || index}>
                    <td>
                      <Link
                        to={`/clients/view-client-detail/${item?.client_id}`}
                        className="text-decoration-none"
                      >
                        {item?.client_name || "—"}
                      </Link>
                    </td>
                    <td>{item?.provider_name || "—"}</td>
                    <td>{item?.application_type || "—"}</td>
                    <td>{item?.oshc_records?.issue_date || "—"}</td>
                    <td>{item?.oshc_records?.expiry_date || "—"}</td>
                    <td>
                      {item?.oshc_records?.amount
                        ? `${Number(item.oshc_records.amount).toFixed(2)}`
                        : "—"}
                    </td>
                    <td>{item?.oshc_records?.provider_name || "—"}</td>
                    <td>
                      <button
                        className="btn btn-primary size-12 m-1"
                        disabled={!item?.oshc_records?.certificate_url}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (item?.oshc_records?.certificate_url) {
                            window.open(
                              item?.oshc_records?.certificate_url,
                              "_blank",
                              "noopener,noreferrer",
                            );
                          }
                        }}
                      >
                        <FaIcons.FaEye size={15} color={"#ffffffed"} />
                      </button>
                      <button
                        className="btn btn-primary size-12 m-1"
                        disabled={!item?.oshc_records?.receipt_url}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (item?.oshc_records?.receipt_url) {
                            window.open(
                              item?.oshc_records?.receipt_url,
                              "_blank",
                              "noopener,noreferrer",
                            );
                          }
                        }}
                      >
                        <FaIcons.FaEye size={15} color={"#ffffffed"} />
                      </button>
                      <button
                        className="btn btn-primary size-12 m-1"
                        onClick={() => {
                          setOpenMoal(true);
                          setSelectedRecord(item);
                        }}
                      >
                        <FaIcons.FaEdit size={15} color={"#ffffffed"} />
                      </button>
                      {!item?.oshc_records && (
                        <button
                          className="btn btn-outline-danger size-12 m-1"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleMarkNotNeeded(
                              item?.client_id,
                              item?.application_id,
                              item?.application_type,
                            );
                          }}
                          title="Mark as Not Needed"
                          disabled={loading}
                        >
                          Not Buy
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          {/* pagination */}
          <div className="row align-items-center mb-5 mt-2 ">
            <div className="col-auto">
              <select
                value={pagination?.perPage}
                onChange={handlePerPageChange}
                className="form-select"
                style={{ minWidth: 80 }}
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
              </select>
            </div>
            <div className="col-auto text-muted">
              Page {pagination.currentPage} – Showing{" "}
              {Math.min(
                pagination.perPage,
                pagination.total -
                  (pagination.currentPage - 1) * pagination.perPage,
              )}{" "}
              of {pagination.total} entries
            </div>
            <div className="col">
              <ReactPaginate
                previousLabel={"Previous"}
                nextLabel={"Next"}
                breakLabel={"..."}
                pageCount={pagination.lastPage}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={handlePageChange}
                forcePage={pagination.currentPage - 1}
                containerClassName={"pagination justify-content-end mb-0"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                activeClassName={"active"}
                disabledClassName={"disabled"}
              />
            </div>
          </div>
        </div>
      </div>
      {/* modal for entering health insurance record */}
      {openModal && (
        <>
          <div
            className="modal-backdrop fade show"
            style={{
              display: "block",
              backgroundColor: "rgba(0,0,0,0.45)",
              zIndex: 1040,
            }}
            onClick={() => setOpenMoal(false)}
          />

          <div
            className="modal fade show d-block"
            tabIndex={-1}
            style={{ zIndex: 1050 }}
          >
            <div
              className="modal-dialog modal-dialog-centered"
              style={{ maxWidth: 700 }}
            >
              <div
                className="modal-content border-0 rounded-4 shadow"
                style={{ overflow: "hidden" }}
              >
                <div
                  className="modal-header"
                  style={{
                    background: "#f7f8fa",
                    borderBottom: "1px solid #eef2f6",
                  }}
                >
                  <h5 className="modal-title fw-bold">Add Insurance Details</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => {
                      setOpenMoal(false);
                      setFieldErrors({});
                    }}
                  />
                </div>

                <div className="modal-body p-4">
                  <form>
                    <div className="row g-3">
                      {/* 1. Start Date of OSHC */}
                      <div className="col-md-6">
                        <label className="form-label fw-medium">
                          Start Date of OSHC
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          value={formData.startDate || ""}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              startDate: e.target.value,
                            });
                            if (fieldErrors.startDate) {
                              setFieldErrors({ ...fieldErrors, startDate: "" });
                            }
                          }}
                        />
                        {fieldErrors.startDate && (
                          <div className="text-danger small mt-1">
                            {fieldErrors.startDate}
                          </div>
                        )}
                      </div>

                      {/* 2. End Date of OSHC */}
                      <div className="col-md-6">
                        <label className="form-label fw-medium">
                          End Date of OSHC
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          value={formData.endDate || ""}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              endDate: e.target.value,
                            });
                            if (fieldErrors.endDate) {
                              setFieldErrors({ ...fieldErrors, endDate: "" });
                            }
                          }}
                        />
                        {fieldErrors.endDate && (
                          <div className="text-danger small mt-1">
                            {fieldErrors.endDate}
                          </div>
                        )}
                      </div>

                      {/* 3. Amount */}
                      <div className="col-md-6">
                        <label className="form-label fw-medium">
                          Amount (AUD)
                        </label>
                        <div className="input-group">
                          <input
                            type="number"
                            className="form-control"
                            placeholder="0.00"
                            min="0"
                            step="0.01"
                            value={formData.amount || ""}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                amount: e.target.value,
                              });
                              if (fieldErrors.amount) {
                                setFieldErrors({ ...fieldErrors, amount: "" });
                              }
                            }}
                          />
                        </div>
                        {fieldErrors.amount && (
                          <div className="text-danger small mt-1">
                            {fieldErrors.amount}
                          </div>
                        )}
                      </div>

                      {/* 4. Provider (Dropdown) */}
                      <div className="col-md-6">
                        <label className="form-label fw-medium">Provider</label>
                        <select
                          className="form-select app-form col-7"
                          name="provider"
                          value={formData.provider || ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            setFormData({ ...formData, provider: value });
                            if (fieldErrors.provider) {
                              setFieldErrors({ ...fieldErrors, provider: "" });
                            }
                          }}
                        >
                          <option value="">Select Provider... </option>
                          {healthProviders?.map((v, index) => (
                            <option
                              key={index}
                              className="light"
                              value={v.title}
                            >
                              {v.title}
                            </option>
                          ))}
                        </select>
                        {fieldErrors.provider && (
                          <div className="text-danger small mt-1">
                            {fieldErrors.provider}
                          </div>
                        )}
                      </div>
                      {/* 5. OSHC Receipt (File Upload) */}
                      <div className="col-12">
                        <label className="form-label fw-medium d-flex align-items-center gap-2">
                          OSHC Receipt
                          {formData.receiptFile && (
                            <span className="badge bg-success">✓ Uploaded</span>
                          )}
                        </label>
                        <input
                          type="file"
                          className="form-control"
                          accept=".pdf,.jpg,.jpeg,.png"
                          onChange={(e) => {
                            const file = e.target.files[0];
                            setFormData({ ...formData, receiptFile: file });
                            if (fieldErrors.receiptFile) {
                              setFieldErrors({
                                ...fieldErrors,
                                receiptFile: "",
                              });
                            }
                          }}
                        />
                        {fieldErrors.receiptFile && (
                          <div className="text-danger small mt-1">
                            {fieldErrors.receiptFile}
                          </div>
                        )}
                      </div>

                      {/* 6. OSHC Certificate (File Upload) */}
                      <div className="col-12">
                        <label className="form-label fw-medium d-flex align-items-center gap-2">
                          OSHC Certificate
                          {formData.certificateFile && (
                            <span className="badge bg-success">✓ Uploaded</span>
                          )}
                        </label>
                        <input
                          type="file"
                          className="form-control"
                          accept=".pdf,.jpg,.jpeg,.png"
                          onChange={(e) => {
                            const file = e.target.files[0];
                            setFormData({ ...formData, certificateFile: file });
                            if (fieldErrors.certificateFile) {
                              setFieldErrors({
                                ...fieldErrors,
                                certificateFile: "",
                              });
                            }
                          }}
                        />
                        {fieldErrors.certificateFile && (
                          <div className="text-danger small mt-1">
                            {fieldErrors.certificateFile}
                          </div>
                        )}
                      </div>
                    </div>
                  </form>
                </div>

                <div
                  className="modal-footer d-flex justify-content-end align-items-center gap-2"
                  style={{
                    background: "#f7f8fa",
                    borderTop: "1px solid #eef2f6",
                  }}
                >
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => {
                      setOpenMoal(false);
                      setFieldErrors({});
                    }}
                    disabled={loading}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn btn-primary"
                    onClick={handleSave}
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" />
                        Saving...
                      </>
                    ) : (
                      <>Update</>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default MedicalInsurance;
